import { ResourceLoader } from './assetsUtils.interface'

export const appendCSSFiles = (urls: string[]): Promise<void[]> => {
    const cssPromises: Promise<void>[] = Object.values(urls).map((url: string) => appendCSS(url))
    return Promise.all(cssPromises)
}

export const appendJSFiles = (urls: string[]): Promise<void[]> => {
    const jsPromises: Promise<void>[] = Object.values(urls).map((url: string) => appendJS(url))
    return Promise.all(jsPromises)
}

const appendCSS: ResourceLoader = (url: string): Promise<void> => {
    return new Promise((resolve, reject): void => {
        const link: HTMLLinkElement = document.createElement('link')
        link.href = url
        link.rel = 'stylesheet'
        link.type = 'text/css'
        link.onload = () => resolve()
        link.onerror = () => reject()

        document.head.appendChild(link)
    })
}

const appendJS: ResourceLoader = (url: string): Promise<void> => {
    return new Promise((resolve, reject): void => {
        const script: HTMLScriptElement = document.createElement('script')
        script.src = url
        script.type = 'text/javascript'
        script.onload = () => resolve()
        script.onerror = () => reject()

        document.head.appendChild(script)
    })
}
